import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { KioskListItem } from '../../interfaces/kiosk';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-kiosks',
  templateUrl: './kiosks.component.html',
  styleUrls: ['./kiosks.component.scss']
})
export class KiosksComponent implements OnInit, AfterViewInit {

  kioskList: KioskListItem[];

  displayedColumns = ['gym.name', 'name', 'version', 'status'];
  dataSource = new MatTableDataSource;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  constructor(private route: ActivatedRoute,
    private translate: TranslateService,
    private globalService: GlobalService) {
    this.kioskList = [];
  }

  ngOnInit() {
    this.kioskList = this.route.snapshot.data.kioskList;

    this.translate.get('KIOSKS.TITLE').subscribe((translation) => {
      this.globalService.changePageTitle([translation]);
    });
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.kioskList);

    // Filter in nested objects
    this.dataSource.filterPredicate = (data, filter: string)  => {
      const accumulator = (currentTerm, key) => {
        return this.nestedFilterCheck(currentTerm, data, key);
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator.firstPage();

    // In order to sort nested objects
    this.dataSource.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'gym.name': return item.gym.name.toLowerCase();
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
  }

  nestedFilterCheck(search, data, key) {
    if (typeof data[key] === 'object') {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }

}
